module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BlackIt.195a18c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-BlackIt.svg
// module id = 359
// module chunks = 3